module.exports = __webpack_public_path__ + "img/logo.b0021613.png";